var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-listado-configuracion-firmas"}},[(!_vm.$vuetify.breakpoint.mobile)?[_c('desktop',{attrs:{"listado":_vm.listado}})]:[_c('mobile')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }